import { render, staticRenderFns } from "./organization-datasubject-category-form.vue?vue&type=template&id=c06bf614"
import script from "./organization-datasubject-category-form.vue?vue&type=script&lang=js"
export * from "./organization-datasubject-category-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports